/**
 * Presentation thresholds for statistics, mirroring the API's own constants.
 *
 * Deliberately NOT in `catalog-client.ts`: that module is `vi.mock`-ed wholesale
 * by several component tests, so a constant living there is `undefined` under
 * test and the importing component fails to render — a threshold is not part of
 * the network surface and should not be mocked away with it.
 */

/**
 * Above this share of a sample sitting on ONE value, a median is that value by
 * construction and must not be read as a market rate. Mirrors
 * `DEGENERATE_MODE_SHARE_PCT` in the API's `base-rates.ts`.
 *
 * Both discount distributions we hold clear it, for opposite reasons —
 * tender-mc enforces a 5% minimum bid step (88.3% of 77,836 rows at exactly
 * 5.00%) and etender competes on technical score, so the winning bid equals the
 * announced price (99.1% of 3,007 rows at exactly 0.00%).
 */
export const DEGENERATE_MODE_SHARE_PCT = 60;
